/**
 * Route for `metrics-cpc-cpa-epc-avg-sale-cr-roi-roas-revenue-payout-profit`. Registered via createRoute; root wires into router.tsx.
 */
import { createRoute } from "@tanstack/react-router";
import { rootRoute } from "../routes/__root";
import { MetricsCpcCpaEpcAvgSaleCrRoiRoasRevenuePayoutProfitPage } from "../features/metrics-cpc-cpa-epc-avg-sale-cr-roi-roas-revenue-payout-profit/MetricsCpcCpaEpcAvgSaleCrRoiRoasRevenuePayoutProfitPage";

export const metricsCpcCpaEpcAvgSaleCrRoiRoasRevenuePayoutProfitRoute = createRoute({
	getParentRoute: () => rootRoute,
	path: "/metrics-cpc-cpa-epc-avg-sale-cr-roi-roas-revenue-payout-profit",
	component: MetricsCpcCpaEpcAvgSaleCrRoiRoasRevenuePayoutProfitPage,
});

export default metricsCpcCpaEpcAvgSaleCrRoiRoasRevenuePayoutProfitRoute;
